<mat-toolbar color="primary">
    <nav>
        <div class="left">
            <a mat-button routerLink="" routerLinkActive="active" ariaCurrentWhenActive="page">
                <mat-icon>checkroom</mat-icon>
                <span>OrgDrobe</span>
            </a>
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/clothes">Clothes</a>
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/outfits">Outfits</a>
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/outfit/generator/random">Randomizer</a>
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/outfit/generator/parameters">Filter</a>
            <!--
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/feed">Feed</a>
            -->
            <!-- 
            <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/search">Search</a>
            -->
        </div>
        <div class="rigth">
            <!-- 
            <a mat-button routerLink="" routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/profile/1">
                <mat-icon>account_circle</mat-icon>
                <span>Profile</span>
            </a>
            -->
            <app-logout></app-logout>
        </div>
    </nav>
</mat-toolbar>

<!-- todo add nav/ol/li -->